import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PplInputIntl {
  decimal = '.'; // decimal symbol
  group = ''; // group separator for thousands

  constructor() { }
}
